import { Link } from "react-router-dom";
import GradientText from "../components/GradientText";
import Seo from "../components/Seo";
import BackgroundVideo from "../components/BackgroundVideo";

const neonColors = ["#fb923c", "#f97316", "#ea580c", "#f59e0b", "#fb923c"];

export default function CateringPage() {
  return (
    <>
      <Seo
        title="Catering"
        description="Book The Canopy catering for private parties, corporate lunches, weddings, and community events."
        path="/catering"
        image="/images/catering.avif"
      />
      {/* Page Header */}
      <section className="relative pt-[calc(80px+60px)] pb-[60px] px-6 text-center overflow-hidden">
        <BackgroundVideo wrapperClassName="absolute inset-0 -z-10" />
        <div className="container">
          <GradientText
            colors={neonColors}
            animationSpeed={6}
            className="text-[clamp(2.5rem,8vw,4.5rem)] mb-4 font-display font-semibold"
          >
            Catering
          </GradientText>
          <p className="text-xl text-text-secondary font-light">
            Let us bring the BBQ to your next event
          </p>
        </div>
      </section>

      {/* Catering Content */}
      <section className="py-[80px] bg-bg-secondary">
        <div className="container">
          <div className="max-w-[900px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Image */}
              <div className="relative rounded-2xl overflow-hidden shadow-lg-custom">
                <img
                  src="/images/catering.avif"
                  alt="The Canopy BBQ"
                  className="w-full h-[300px] lg:h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>

              {/* Content */}
              <div>
                <h2 className="font-display text-2xl font-semibold text-text-primary mb-6">
                  Make Your Event Unforgettable
                </h2>
                <p className="text-text-secondary text-lg leading-relaxed mb-6">
                  Looking for something special for your next gathering? The
                  Canopy offers full-service catering for private events of all
                  sizes. Whether it's a corporate lunch, graduation party,
                  wedding reception, family reunion, or any celebration, we'll
                  bring our signature pit beef, smoky BBQ, and bold flavors
                  right to you.
                </p>
                <p className="text-text-secondary text-lg leading-relaxed mb-8">
                  We can customize our menu to fit your needs and budget. From
                  intimate gatherings to large events, we've got you covered
                  with fresh food that your guests will love.
                </p>

                <div className="flex flex-wrap gap-4 mb-8">
                  <Link to="/menu/catering" className="btn btn-primary btn-large">
                    View Catering Menu
                  </Link>
                </div>

                <div className="bg-bg-card border border-border-default rounded-xl p-6">
                  <h3 className="font-display font-semibold text-text-primary mb-3">
                    Ready to Start Planning?
                  </h3>
                  <p className="text-text-secondary mb-5">
                    Reach out to us and let's start planning your event. We'd
                    love to hear from you!
                  </p>
                  <Link to="/contact" className="btn btn-primary btn-large">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
